export enum WorkflowMailStatus {
    NONE = 'None',
    REMINDER_1 = 'Reminder1',
    REMINDER_2 = 'Reminder2'
}
